import * as z from 'zod/mini';
import { ActorEvent } from './ActorEvent.js';
import { ActorReady } from './ActorReady.js';
import { ActorResponse } from './ActorResponse.js';
/**
 * Union of all server-to-client message types.
 * Used for parsing incoming messages on the client side.
 */
export const ActorEgress = z.discriminatedUnion('type', [ActorEvent, ActorReady, ActorResponse]);
//# sourceMappingURL=ActorEgress.js.map